<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex align-items-center mb-3">
        <div class="avatar-xs me-3">
          <span class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-18">
            <i class="bx bx-car"></i>
          </span>
        </div>
        <h5 class="font-size-14 mb-0">
          Overall Traffic Details
        </h5>
      </div>
      <ul class="list-group" v-if="locationwiseTrafficCount && locationwiseTrafficCount.length > 0">
        <simplebar style="max-height: 36vh;">
          <li class=" list-group-item border-0 m-0 p-0 mt-2 mb-2" v-for="location in locationwiseTrafficCount"
            :key="location.id">
            <div class="d-flex">
              <div class="flex-grow-1">
                <h5 class="font-size-12 text-warning mb-1">
                  Location {{
                    location.location
                  }} KM - {{ location.count }} Vehicles
                </h5>
                <p class="text-muted font-size-11">
                  <!-- {{ new Date(location.reported_datetime).toLocaleString() }} -->
                </p>
              </div>
            </div>
            <hr class="mt-0 mb-0" />
          </li>
        </simplebar>
      </ul>
      <div v-else-if="locationwiseTrafficCount.length === 0" style="height: 37vh" class="text-center">
        <p class="pt-5">No Traffic Data</p>
      </div>
      <div v-else style="height: 37vh">
        <widgetLoader />
      </div>
    </div>
  </div>
</template>
<script>
import simplebar from "simplebar-vue";
import incidentMixin from "../../mixins/incident";
import VueEasyLightbox from "vue-easy-lightbox";
import widgetLoader from "@/components/widgets/widget-loader";

export default {
  mixins: [incidentMixin],
  components: { simplebar, VueEasyLightbox, widgetLoader },
  data () {
    return {
      recentIncidents: [],
    };
  },

  methods: {
    ShowIncidentDetails (incident) {
      this.$router.push(`/incident/view-incident-details/${incident.id}`);
    },

    getReadableDateTime (dateTime) {
      if (dateTime) {
        // const date = String(dateTime).split("T");
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },
  },
  mounted () {
    setInterval(() => {
      if (this.recentIncidents && this.recentIncidents.length === 0) {
        this.recentIncidents = this.locationwiseTrafficCount;
      } else {
        if (
          this.recentIncidents &&
          this.recentIncidents[0] &&
          this.recentIncidents[0].id !== this.locationwiseTrafficCount[0].id
        ) {
          this.recentIncidents = this.locationwiseTrafficCount;
          if (this.$store.getters["incident/liveAlert"]) {
            if (
              this.recentIncidents[0].category_name &&
              this.recentIncidents[0].sub_category_name
            ) {
              this.$toast.warning(
                `${this.recentIncidents[0].category_name}:${this.recentIncidents[0].sub_category_name} Detected by ${this.recentIncidents[0].source_name}`,
                {
                  onClick: () => {
                    this.ShowIncidentDetails(this.recentIncidents[0]);
                  },
                }
              );
            }
          }
        }
      }
    }, 1000);
  },
  computed: {
    locationwiseTrafficCount () {
      return this.$store.getters["socket/dashboard"].statistics
        .locationwiseTrafficCount;
    },
  },
};
</script>

<style scoped>
.image {
  height: 100px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
